import { memo, useRef } from 'react';
import clsx from 'clsx';
import { useOtherSettings } from '@namespace/cms';
import { useDeviceStore, useScreenSize } from '@namespace/device';
import { IS_SERVER_RENDER } from '@namespace/helpers';
import { useThemesStore } from '@namespace/themes';
import Loader from '../../common/Loader';
import { useInternalLinkNavigation } from './useInternalLinkNavigation';
import { usePrepareContent } from './usePrepareContent';

import styles from './index.module.css';

// from https://github.com/christo-pr/dangerously-set-html-content/blob/master/src/index.js

const InnerHtmlContent = ({ html, className, snippetId, ...rest }) => {
  const { colorScheme } = useThemesStore();
  const { activeTheme, activeColorScheme } = colorScheme;
  const divRef = useRef(null);
  const screenType = useScreenSize(false);
  const { pageType } = useDeviceStore();
  const { isSnippetShadowRootEnabled = false } = useOtherSettings();

  const { isLoaded, withLoader } = usePrepareContent(divRef, html);

  useInternalLinkNavigation(divRef);

  return (
    <div
      className={clsx(
        'snippet',
        className,
        isSnippetShadowRootEnabled &&
          clsx(activeTheme, activeColorScheme, pageType, screenType)
      )}
    >
      {withLoader && !isLoaded ? (
        <div className={styles.overlay}>
          <Loader />
        </div>
      ) : null}
      <div
        ref={divRef}
        className={clsx({ [styles.hidden]: withLoader && !isLoaded })}
        {...(IS_SERVER_RENDER && window.IS_SSR
          ? {
              dangerouslySetInnerHTML: {
                __html: html
              }
            }
          : {})}
        {...rest}
      />
    </div>
  );
};

export default memo(InnerHtmlContent);
